module.exports = __webpack_public_path__ + "static/media/e37313f1-0680-4871-8fb1-39335612526a.6703a6a9.JPG";